
import './style.less'

import { h, Fragment } from 'preact'
import { useState, useRef, useLayoutEffect } from 'preact/hooks'
import classnames from 'classnames'

import TitleText from '@components/title-text'
import ImageLoad from '@components/image-load'
import BrowserChrome from '@components/browser-chrome'
import VideoInline from '@components/video-inline'

import { withHydration } from '@util/hydrate'
import { useIsIntersecting } from '@util/intersection'
import { ButtonIconArrowDownScroll } from '@components/button'

const Splash = ({ 
	title = '', 
	subtitle = '', 
	href = null,
	image = {}, 
	video = {},
	showButton = false, 
	list = [],
	browser = false,
	domain = '',
	spacer = false
}) => {

	const [ref, shown] = useIsIntersecting('-10% 0px')
	const [browserRef, browserShown] = useIsIntersecting('-10% 0px', true)

	const background = <>
		{ image && <ImageLoad {...image} loading="eagar" class={ browser ? 'fit-width' : 'object-fit object-fit--fill' }></ImageLoad> }
		{ video && <VideoInline {...video} autoplay muted class={ browser ? 'fit-width' : 'object-fit object-fit--fill' }></VideoInline> }
	</>

	const Background = href ? 'a' : 'div'
	const showList = list.length || null

	const classes = classnames(
		'splash-container',
		spacer && 'splash-container--large'
	)

	return (
		<section class={classes}>
			<Background href={href} className="splash">

				{/* uses '__bg' for images, auto-fits image to aspect ratio */}
				{ !browser && <div className="splash__bg">
					{ background }
				</div> }

				{/* uses '__bg-auto' for browser/videos, aspect ratio determined by content */}
				{ browser && <div ref={browserRef} className="splash__bg-auto" style={{ opacity : browserShown ? 1 : 0 }}>
					<BrowserChrome url={domain}>
						{ background }
					</BrowserChrome>
				</div> }

				{ (title || subtitle) && 
					<div ref={ref} className="splash__overlay">	
						<TitleText lines={[ title, subtitle ]} trigger={shown} />
					</div>
				}
			</Background>

			{ showButton && 
				<div class="splash__button">
					<ButtonIconArrowDownScroll showCircleHover={true} />
				</div> 
			}

			{ showList && 
				<ul class="splash__list">
					{list.map((item) => {
						return <ul class="splash__list__item">{item}</ul>
					})}
				</ul> 
			}
	    </section>
	)
}


export default withHydration(Splash)